import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../../pages/authentication/auth.service';

export const authTokenInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const authSvc = inject(AuthService);
  const token = authSvc.getToken();
  const router = inject(Router);
  const authReq = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(authReq).pipe(
    catchError((error) => {
      if (error.status === 401 && authSvc.getRefreshToken()) {
        return authSvc.refreshTokenRequest().pipe(
          switchMap((token) => {
            const newToken = token.token;
            const retryReq = newToken
              ? req.clone({
                  setHeaders: { Authorization: `Bearer ${newToken}` },
                })
              : req;
            return next(retryReq);
          }),
          catchError(() => {
            // Save current route before logout if it's not already a login/auth route
            const currentUrl = router.url;
            if (
              !currentUrl.includes('/login') &&
              !currentUrl.includes('/auth')
            ) {
              //authSvc.saveIntendedRoute(currentUrl);
            }
            return authSvc.logout(true);
          }),
        );
      }
      return throwError(() => error);
    }),
  );
};
